export default __webpack_public_path__ + "static/media/users.03dfcc18.svg";